"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function Metrics(_a) {
    var _b, _c, _d;
    var metrics = _a.metrics;
    return react_1.default.createElement(storybook_1.Cards.Row, null,
        react_1.default.createElement(storybook_1.Graphs.Card, { title: 'Totale weergaven', current: (_b = metrics.views) !== null && _b !== void 0 ? _b : 0 }),
        react_1.default.createElement(storybook_1.Graphs.Card, { title: 'Unieke weergaven', current: (_c = metrics.views_unique) !== null && _c !== void 0 ? _c : 0 }),
        react_1.default.createElement(storybook_1.Graphs.Card, { title: 'Totale kijktijd', current: storybook_1.Helpers.toHHMMSS((_d = metrics.time_watched) !== null && _d !== void 0 ? _d : 0) }));
}
exports.default = Metrics;
